import CommManager from '../../../vendor_core/core/src/controllers/CommManager';
import RealityCheckModel from '../../../vendor_core/core/src/model/RealityCheckModel';
import RequestRegister from '../../../vendor_core/core/src/server/requests/RequestRegister';
import { RealityCheckState } from '../../../vendor_core/core/src/states/RealityCheckState'
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';

export default class BBRealityCheckState extends RealityCheckState {
    protected showRealityCheck = () => {
        CommManager.send(RequestRegister.get("getBalance"), ({realityCheck})=> {
            RealityCheckModel.totalBet = realityCheck.betSum;
            RealityCheckModel.totalWin = realityCheck.winSum;
            super.showRealityCheck();
            // show popup background
            ViewManager.getLayer("PopupsBackground").setScene("open");
        }, true)
    }

    public exit = () => {
        super.exit();
        // clear popup background
        ViewManager.getLayer("PopupsBackground").clear();
    }
}
